// extracted by mini-css-extract-plugin
export default {"manage-mari-grid-popup-client-name":"manage-maris-grid_manage-mari-grid-popup-client-name__upXQY"};